"use client";
export { useFavorites } from "@/lib/favorites/favorites-context";
